import Button from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ref: ref, className: props.className },
        React.createElement(Button, { buttonType: "text-only", "aria-label": "Previous", disabled: !props.wrap && carousel.activeIndex === 0, onClick: (event) => {
                event.preventDefault();
                carousel.goToPrev(props.wrap);
            }, iconOnly: true, "data-prev": true }),
        React.createElement(Button, { buttonType: "text-only", "aria-label": "Next", disabled: !props.wrap && carousel.activeIndex === carousel.maxIndex, onClick: (event) => {
                event.preventDefault();
                carousel.goToNext(props.wrap);
            }, iconOnly: true, "data-next": true })));
});
Controls.displayName = 'Controls';
export default Controls;
